export const qrVideosKeys = {
  all: () => ['QR_VIDEOS'] as const,
};
